export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'AsianTrips'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
    };

    static readonly defaultOffer = '- حجوزات الفنادق في كل مدينة شاملة جميع الضرائب ورسوم البلديات.\n- جميع الفنادق مع الإفطار في بوفيه مفتوح.\n- رحلات الطيران الداخلية ( بانكوك << بوكيت << بانكوك)\nمع إضافة وزن الحقائب 20 لكل شخص.\n- سيارة وسائق خاص وجولات سياحية\n( لا يشمل رسوم تذاكر دخول المواقع السياحية ).\n- الاستقبال والتوديع في كل المطارات\nبوابة رقم 4 للطيران الدولي / بوابة 3 - 4 للطيران الداخلي.\n- الدعم المستمر للمسافر في جميع الأوقات.\n- العرض يعتبر عرض سعر مبدئي قابل للتغيير بحسب التوافر والإتاحة.';

    static readonly dayNames = [
        "اليوم الأول",
        "اليوم الثاني",
        "اليوم الثالث",
        "اليوم الرابع",
        "اليوم الخامس",
        "اليوم السادس",
        "اليوم السابع",
        "اليوم الثامن",
        "اليوم التاسع",
        "اليوم العاشر",
        "اليوم الحادي عشر",
        "اليوم الثاني عشر",
        "اليوم الثالث عشر",
        "اليوم الرابع عشر",
        "اليوم الخامس عشر",
        "اليوم السادس عشر",
        "اليوم السابع عشر",
        "اليوم الثامن عشر",
        "اليوم التاسع عشر",
        "اليوم العشرون",
    ];
    
}
